export const serviceUris = {
  assets: 'assets/',
  authBase: 'dealers/',
  dealers: 'v1/dealers',
  getDealerSetup: 'v1/dealers/getDealerSetup',
  updateDealerSetup: 'v1/dealers/updateDealerSetup',
  updatePosSetup: 'v1/dealers/updatePOSSetup',
  getAllPlantTransfer: 'v1/dealers/getAllPlantTransfer',
  deletePlantTransfer: 'v1/dealers/deletePlantTransfer',
  updatePlantTransfer: 'v1/dealers/updatePlantTransfer',
  getNewDealerPlantTransferPk: 'v1/dealers/getNewDealerPlantTransferPk',
  translations: 'translations',
  specifications: 'v1/specifications',
  mrtSpecification: 'v1/specifications/mrt',
  searchSpecification: 'v1/specifications/search',
  products: 'v1/products',
  getPartNumberList: 'preMold/rollPartNumbers',
  getFilteredCustomMolds: 'customMold',
  getAllCustomMolds: 'productData/getAllCustomMolds',
  updateCustomMolds: 'productData/updateCustomMolds',
  getAllPreMolds: 'productData/getAllPreMolds',
  getAllMakes: 'productData/getAllMakes',
  getAllMakeFilters: 'productData/getAllMakeFilters',
  getAllGrades: 'productData/getAllGrades',
  getAllGradeFilters: 'productData/getAllGradeFilters',
  updateGrades: 'productData/updateCasingGrades',
  deleteGrade: 'productData/deleteCasingGrade',
  getNewGradeId: 'productData/getNewCasingGradePk',
  checkGradeTableRules: 'productData/getCasingGradeTableRules',
  getAllGradeTableFilters: 'productData/getAllGradeTableFilters',
  getAllCasingGradeTable: 'productData/getAllCasingGradeTable',
  createCasingGradeTable: 'productData/createCasingGradeTable',
  updateCasingGradeSpecifications: 'productData/updateCasingGradeSpecifications',
  getAllFinishedProducts: 'productData/getAllFinishedProduct',
  updateFinishedProducts: 'productData/updateFinishedProduct',
  getAllCasingSizes: 'productData/getAllCasingSize',
  updateCasingSizes: 'productData/updateCasingSize',
  getAllCasingDefinitions: 'productData/getAllCasingDefinition',
  getAllCasingFitments: 'productData/getAllCasingFitment',
  getAllFactoryCodes: 'productData/getAllFactoryCode',
  getAllAdjustmentReasons: 'productData/getAllAdjustmentReasons',
  getFactoryCodeFilters: 'productData/getAllFactoryCodeFilters',
  getAdjustmentReasonsFilters: 'productData/getAllAdjustmentReasonFilters',
  getAllRefInfos: 'productData/getAllReferenceInformation',
  getAllDisposalCharges: 'productData/getAllDisposalCharges',
  getDisposalChargeByDescription: 'productData/getDisposalChargeByDescription',
  getDisposalChargeById: 'productData/getDisposalChargeById',
  getDefaultCasingGrade: 'productData/getDefaultCasingGrade',
  getAllCasingGradeSpecification: 'productData/getAllCasingGradeSpecification',
  deleteCasingGradeTable: 'productData/deleteCasingGradeTable',
  deleteCasingGradeSpecification: 'productData/deleteCasingGradeSpecification',
  updateDisposalCharges: 'productData/updateDisposalCharges',
  updatePreMolds: 'productData/updatePreMold',
  updateMakes: 'productData/updateMake',
  updateRepairs: 'productData/updateRepairs',
  getAllCasingSizesFilter: 'productData/getCasingSizeSearchFilters',
  getAllCasingCreditDetailsFilter: 'productData/getCasingCreditDetailsSearchFilters',
  getAllCasingCredits: 'productData/getAllCasingCredit',
  getCasingCreditDetails: 'productData/getCasingCreditDetails',
  updateCasingCreditDetails: 'productData/updateCasingCreditDetails',
  casingCreditCodeExists: 'productData/checkCasingCreditCode',
  freeRepairCodeExists: 'productData/checkFreeRepairCode',
  updateFreeRepairs: 'productData/updateFreeRepairs',
  createFreeRepairTableRecord: 'productData/createFreeRepairTableRecord',
  deleteFreeRepairTableRecord: 'productData/deleteFreeRepairTableRecord',
  checkCasingGradeCode: 'productData/checkCasingGradeCode',
  getCasingCreditDetailsForCreateCasingCredit: 'productData/getCasingCreditDetailsForCreateCasingCredit',
  createCasingCredit: 'productData/createCasingCredit',
  getAllCasingCreditsFilter: 'productData/getCasingCreditSearchFilters',
  getCasingCreditRepairGridSearchFilters: 'productData/getCasingCreditRepairGridSearchFilters',
  getAllCasingRepairs: 'productData/getAllCasingCreditRepairs',
  getAllCasingCreditRepairsFilter: 'productData/getAllCasingRepairSearchFilters',
  getAllCasingCreditRepairDetailsFilter: 'productData/getCasingCreditRepairDetailSearchFilters',
  getAllCasingCreditRepairDetails: 'productData/getCasingCreditRepairDetails',
  updateCasingRepairDetails: 'productData/updateCasingCreditRepairDetails',
  createCasingCreditRepair: 'productData/createCasingCreditRepair',
  saveCasingCreditRepair: 'productData/saveCasingCreditRepair',
  getAllPaginatedRepairs: 'productData/getAllPaginatedRepairs',
  getAllRepairs: 'productData/getAllRepairs',
  deleteCasingCredit: 'productData/deleteCasingCredit',
  deleteCasingCreditRepair: 'productData/deleteCasingCreditRepair',
  assignCustomerCasingCredit: 'productData/assignCasingCreditToCustomers',
  copyCasingCredit: 'productData/copyCasingCredit',
  getRejectReasons: 'productData/getRejectReasons',
  getAllRejectReasonFilters: 'productData/getAllRejectReasonFilters',
  getRepairFilterValues: 'productData/getRepairFilterValues',
  productCombinations: 'v1/products/checkValidProductCombinations',
  searchCustomer: 'v1/specifications/searchCustomer',
  assignCustomer: 'v1/specifications/assignCustomer',
  duplicateCamSpec: 'v1/specifications/duplicateCam',
  searchAssigned: 'v1/specifications/viewAssignedCustomers',
  searchNafaAssigned: 'v1/specifications/viewNafaAssignedCustomers',
  getCustomers: 'customers',
  getCustomerSettings: 'customers/settings',
  camNameCheck: 'v1/specifications/exists',
  getPreferredTread: 'v1/preferredTread/getAll',
  getAllCamSpecNames: 'v1/specifications/getAllCamSpecNames',
  getUsers: 'assets/dealers/{dealerId}/users/search',
  getSalesmen: 'assets/dealers/{dealerId}/users/salesmen',
  getLoginNames: 'v1/auditTrail/auditUsers',
  getAuditExportLimit: 'v1/auditTrail/getAuditExportLimit',
  getGroups: 'assets/dealers/{dealerId}/users/groups',
  getUserGroups: 'assets/dealers/{dealerId}/users/getUserGroups',
  getUserGroupDetails: 'assets/dealers/{dealerId}/users/getUserGroupDetail',
  updateUserGroup: 'assets/dealers/{dealerId}/users/updateUserGroup',
  saveUserGroup: 'assets/dealers/{dealerId}/users/saveUserGroup',
  getAssociateCustomer: 'customers/getAssociateCustomers',
  resetPassword: 'assets/dealers/{dealerId}/users/resetPassword',
  getAllPlants: 'plants/all',
  updatePlantAssociation: 'plants/assign',
  updatePlantAssociationForFinishedProduct: 'plants/assignPlantsToFinishedProduct',
  featureFlags: 'featureflags/dealers/{dealerId}',
  externalApiConfig: 'featureflags/dealers/{dealerId}/externalApiConfig',
  unlockAccount: 'assets/dealers/{dealerId}/users/unlockAccount',
  getPlants: 'plants/getPlants',
  getSites: 'sites/getSites',
  getPaginatedSites: 'sites/getPaginatedSites',
  getSiteDetails: 'sites/getSiteDetails',
  updateSite: 'sites/updateSite',
  getAllActiveInactivePlants: 'plants/getAllPlants',
  getPlantAndZoneSettings: 'plants/getPlantZoneSettings',
  searchPackList: 'v1/packlist/getPackLists',
  searchPackListDetails: 'v1/packlist/getPackListDetails',
  getPackListDetails: 'v1/packlist/packlistData',
  deletePackList: 'v1/packlist/deletePackList',
  searchBoAuditList: 'v1/boAuditTrail/getBackOfficeAuditTrail',
  searchBoAuditExportList: 'v1/boAuditTrail/exportBackOfficeAuditTrail',
  fetchBoAuditTrailByCasing: 'v1/boAuditTrail/casing/{casingId}',
  searchAuditList: 'v1/auditTrail/getAuditTrail',
  searchAuditExportList: 'v1/auditTrail/getAuditTrailExport',
  searchTransactionLog: 'v1/transactionLog/getTransactionLog',
  getTransactionTypes: 'v1/transactionLog/getTransactionTypes',
  getAllReferential: 'customers/getAllReferential',
  getProductionCustomers: 'customers/production',
  updateCustomerDetails: 'customers/update',
  addUser: 'assets/dealers/{dealerId}/users/addUser',
  deleteGroup: 'assets/dealers/{dealerId}/users/deleteGroup',
  updateUser: 'assets/dealers/{dealerId}/users/updateUser',
  customerCodeExists: 'customers/checkCode',
  searchUserAssignToCustomer: 'customers/searchUserAssignToCustomer',
  searchUserCustomer: 'customers/searchCustomers',
  lookupCustomerByCode: 'customers/lookupByCode',
  getCustomersForDropdown: 'customers/getCustomersForDropdown',
  syncLabels: 'labels/syncLabels',
  importProducts: 'productData/importProducts',
  searchWorkOrders: 'assets/dealers/{dealerId}/workorders/search',
  exportWorkOrders: 'assets/dealers/{dealerId}/workorders/woExport',
  searchWorkOrderLine: 'assets/dealers/{dealerId}/workOrders/{workOrderHeaderId}/workOrderLines',
  workOrderLineExtendedDetails:
    'assets/dealers/{dealerId}/workOrders/{workOrderHeaderId}/workOrderLines/{workOrderLineId}/extended-details',
  workOrderLineExtendedDetailsWithHeader:
    'assets/dealers/{dealerId}/workOrders/{workOrderHeaderId}/workOrderLines/{workOrderLineId}/extendedDetailsWithHeader',
  fetchWorkOrderLineLocationInfo: 'assets/dealers/{dealerId}/workOrders/{workOrderHeaderId}/workOrderLines/{workOrderLineId}/locationInfo',
  searchCasingCreditAssignToCustomer: 'customers/searchCasingCreditAssignToCustomer',
  getFinishedProduct: 'assets/dealers/{dealerId}/workOrders/{workOrderHeaderId}/workOrderLines/{workOrderLineId}/getFinishedProduct',
  fetchWolSfAuditTrailInfo:
    'assets/dealers/{dealerId}/workOrders/{workOrderHeaderId}/workOrderLines/{workOrderLineId}/getShopFloorAuditTrailInfo',
  getAllFreeRepairs: 'productData/getAllFreeRepairTable',
  getAllFreeRepairsFilter: 'productData/getFreeRepairSearchFilters',
  getFreeRepairDetails: 'productData/getFreeRepairDetails',
  getFreeRepairDetailsForCreate: 'productData/getFreeRepairDetailsForCreate',
  createCasingRepairDetails: 'productData/updateCasingCreditRepairDetails',
  searchCasingGradeTableAssignToCustomer: 'customers/searchCasingGradeTableAssignToCustomer',
  casingSearch: 'assets/dealers/{dealerId}/casings/search',
  getMakesForDealer: 'productData/dropdown/makes',
  getValidMakesForDealer: 'productData/dropdown/validMakes',
  getTreadWidthsForDealer: 'productData/dropdown/treadWidths',
  getCasingSeriesForDealer: 'productData/dropdown/series',
  getCasingSizesForDealer: 'productData/dropdown/sizes',
  getTreadsForDealer: 'productData/dropdown/treads',
  getTreadsForDealerFilter: 'productData/dropdown/filterTreads',
  getTreadLengthsForDealer: 'productData/dropdown/treadLengths',
  getApplicationCodesForDealer: 'productData/dropdown/applicationCodes',
  getAxleCodesForDealer: 'productData/dropdown/axleCodes',
  getWheelCodesForDealer: 'productData/dropdown/wheelCodes',
  getWheelColorsForDealer: 'productData/dropdown/wheelColors',
  getRejectReasonsForDropdown: 'productData/dropdown/rejectReasons',
  getPlantProcessCode: 'assets/dealers/{dealerId}/casings/getPlantProcessCode',
  getLineProcessCode: 'assets/dealers/{dealerId}/casings/getLineProcessCode',
  checkTransferCasings: 'assets/dealers/{dealerId}/casings/transfer',
  getAllRerunReworkReasons: 'productData/getAllRerunReworkReasons',
  getAllRerunReworkReasonsFilter: 'productData/getRerunReworkReasonsSearchFilters',
  updateRejectReasons: 'productData/updateRejectReasons',
  updatePlant: 'plants/savePlantSetup',
  getZoneDetails: 'zone/getZoneDetails',
  updateZoneSetup: 'zone/updateZoneSetup',
  getPreferredTreads: 'productData/getPaginatedPreferredTreadSpecifications',
  getPreferredTreadsFilters: 'productData/getPreferredTreadsFilters',
  getPreferredTreadSpecifications: 'productData/getPaginatedPreferredTreads',
  getCustomerData: 'customers/search',
  searchPreferredTreadSpecificationsAssignToCustomer: 'productData/searchPreferredTreadSpecificationsAssignToCustomer',
  assignPreferredTreadSpecificationsToCustomers: 'productData/assignPreferredTreadSpecificationsToCustomers',
  searchFreeRepairs: 'productData/searchFreeRepairsAssignToCustomer',
  assignFreeRepairsToCustomers: 'productData/assignFreeRepairToCustomers',
  assignCasingGradeTableToCustomers: 'productData/assignCasingGradeTableToCustomers',
  updateWorkOrderHeader: 'assets/dealers/{dealerId}/workorders/{workOrderHeaderId}',
  getWorkOrderLineEditInitialLoad:
    'assets/dealers/{dealerId}/workOrders/{workOrderHeaderId}/workOrderLines/{workOrderLineId}/getWorkOrderLineEditInitialLoad',
  refreshSeries: 'v1/products/dealer/{dealerId}/workOrderLine/refreshSeries/{makeId}',
  refreshSizes: 'v1/products/dealer/{dealerId}/workOrderLine/refreshSizes/{makeId}/{seriesId}',
  refreshTread: 'v1/products/dealer/{dealerId}/workOrderLine/{workOrderLineId}/refreshTreads',
  verifyDotDetails: 'assets/dealers/{dealerId}/workOrders/{workOrderHeaderId}/workOrderLines/validateMfgDotAndRDot',
  canPreferredTreadSpecBeDeleted: 'productData/canPreferredTreadSpecBeDeleted',
  deletePreferredTread: 'productData/deletePreferredTread',
  updatePreferredTreads: 'productData/updatePreferredTreads',
  deletePreferredTreadSpec: 'productData/deletePreferredTreadSpec',
  getNewPreferredTreadPk: 'productData/getNewPreferredTreadPk',
  updatePreferredTreadSpecs: 'productData/updatePreferredTreadSpecs',
  updatePreferredTreadWithSpec: 'productData/updatePreferredTreadWithSpec',
  validateCams: 'v1/specifications/validateCamSpec',
  matchingCamSpec: 'v1/specifications/matchingCamSpec',
  validateCombination: 'assets/dealers/{dealerId}/workOrders/{workOrderHeaderId}/workOrderLines/{workOrderLineId}/validateCombination',
  getDealerDateFormat: 'v1/dealers/{dealerId}/dateFormat',
  getPosEnabled: 'v1/dealers/{dealerId}/posEnabled',
  calculateCasingGrade: 'assets/dealers/{dealerId}/workOrders/{workOrderHeaderId}/workOrderLines/{workOrderLineId}/calculateCasingGrade',
  saveWorkOrderLineChanges: 'assets/dealers/{dealerId}/workOrders/{workOrderHeaderId}/workOrderLines/{workOrderLineId}/saveChanges',
  getNewTdmsId: 'plants/getNewTdmsId',
  deleteTdmsProperties: 'plants/deleteTdmsProperties',
  updateTdmsProperties: 'plants/updateTdmsProperties',
  getDealerConfigs: 'v1/dealers/{dealerId}/dealerConfigs',
  createWorkOrder: 'assets/dealers/{dealerId}/workorders/createWorkOrder',
  markDeleteAndSaveWorkOrder: 'assets/dealers/{dealerId}/workorders/{workOrderHeaderId}/markDeleteAndSaveWorkOrder',
  markDeleteAndSaveCasing:
    'assets/dealers/{dealerId}/workOrders/{workOrderHeaderId}/workOrderLines/{workOrderLineId}/markDeleteAndSaveCasing',
  markDeleteAndSaveCasingsBulk: 'assets/dealers/{dealerId}/casings/workOrderLines/markSelectedWOLDeleted',
  validateWorkOrderNumber: 'assets/dealers/{dealerId}/workorders/validateNumber',
  markWorkOrderReleased: 'assets/dealers/{dealerId}/workOrders/{workOrderHeaderId}/workOrderLines/markWorkOrderReleased',
  markSelectedWOLReleased: 'assets/dealers/{dealerId}/workOrders/{workOrderHeaderId}/workOrderLines/markSelectedWOLReleased',
  workOrderDetails: 'assets/dealers/{dealerId}/workorders/details/{workOrderHeaderPk}',
  nextBarcode: 'assets/dealers/{dealerId}/workorders/nextBarcode',
  validateBarcodes: 'assets/dealers/{dealerId}/workorders/validateBarcodes',
  validateLineBarcode: 'assets/dealers/{dealerId}/workorders/validateLineBarcode',
  validateRtDot: 'assets/dealers/{dealerId}/workorders/validateRtDot',

  // Hub Log
  searchHubLogList: 'v1/hub/getHubLogs',
  searchHubEventLogList: 'v1/hub/getHubLogDetails',
  getHubProcessList: 'v1/hub/nativeIds',
  deleteHubLog: 'v1/hub/remove',
  clearHubLogs: 'v1/hub/clearLogs',
  // Wheels
  getAllWheels: 'productData/getAllWheels',
  getAllWheelFilters: 'productData/getAllWheelFilters',
  updateWheels: 'productData/updateWheels',
  deleteWheel: 'productData/deleteWheel',
  getNewWheelPk: 'productData/getNewWheelPk',
  // Wheel Colors
  getAllWheelColors: 'productData/getAllWheelColors',
  getAllWheelColorFilters: 'productData/getAllWheelColorFilters',
  updateWheelColors: 'productData/updateWheelColors',
  deleteWheelColor: 'productData/deleteWheelColor',
  getNewWheelColorPk: 'productData/getNewWheelColorPk',
  // Email Setup
  getAllEmailSetups: 'productData/getAllEmailSetups',
  getAllEmailSetupFilters: 'productData/getAllEmailSetupFilters',
  updateEmailSetup: 'productData/updateEmailSetup',
  deleteEmailSetup: 'productData/deleteEmailSetup',
  getNewEmailSetupPk: 'productData/getNewEmailSetupPk',

  getAllSitesForDropdown: 'sites/getAllSites',
  getAllCustomersForDropdown: 'customers/getAllActiveCustomers',
  getStockMovementMetadata: 'inventory/stock-movements/metadata',
  searchStockMovements: 'inventory/stock-movements/list',
  submitStockMovement: 'inventory/stock-movements/history',
  getRawMaterials: 'inventory/stock-movements/raw-materials',
  // Setup Screens
  getZoneSettings: 'plants/getZoneSettings',
  createPlant: 'plants/createPlant',
  // Casing Purchase
  getAllCasingPurchases: 'productData/getAllCasingPurchase',
  getAllCasingPurchasesFilter: 'productData/getCasingPurchaseSearchFilters',
  getCasingPurchaseDetails: 'productData/getCasingPurchaseDetails',
  getCasingPurchaseDetailsFilter: 'productData/getCasingPurchaseDetailsSearchFilters',
  searchCasingPurchaseAssignToCustomer: 'customers/searchCasingPurchaseAssignToCustomer',
  assignCustomerCasingPurchase: 'productData/assignCasingPurchaseToCustomers',
  getCasingPurchaseDetailsForCreateCasingPurchase: 'productData/getCasingPurchaseDetailsForCreateCasingPurchase',
  createCasingPurchase: 'productData/createCasingPurchase',
  casingPurchaseCodeExists: 'productData/checkCasingPurchaseCode',
  updateCasingPurchaseDetails: 'productData/updateCasingPurchaseDetails',
  getCasingValue: 'assets/dealers/{dealerId}/workorders/getCasingValue',
  deriveWorkType: 'assets/dealers/{dealerId}/workorders/deriveWorkType',
  getSystemGrade: 'assets/dealers/{dealerId}/workorders/getSystemGrade',
  transferToExistingWo: 'assets/dealers/{dealerId}/casings/transfer/existing-workorder',

  // Dataset Download
  datasetDownload: 'v1/datasetDownload',

  // Kube Jobs
  kubejobs: 'v1/kubejobs',
  kubejobDetail: 'v1/kubejobs/{cronJobName}',
  kubejobTrigger: 'v1/kubejobs/{cronJobName}/trigger',
  kubejobRestart: 'v1/kubejobs/{cronJobName}/restart',
  kubejobSuspend: 'v1/kubejobs/{cronJobName}/suspend',
  kubejobSchedule: 'v1/kubejobs/{cronJobName}/schedule',
  kubejobKill: 'v1/kubejobs/{cronJobName}/kill',

  // Password Notification
  passwordStatus: 'assets/dealers/{dealerId}/users/{login}/password-status',
  passwordNotification: 'assets/dealers/{dealerId}/users/{login}/password-notification',

  // Banner Notifications
  notificationBanners: 'admin/banners',
  currentNotificationBanner: 'backoffice/banner/current'
};
